import { ButtonBase, Stack, Typography, useTheme } from "@mui/material";
import { ChevronDown, ChevronLeft, ChevronRight } from "lucide-react";
import type { FC } from "react";
import { FlatRowDatePanelArrow } from "web_myplann/Shared/Components/FlatRow/FlatRowDatePanelArrow";

type Props = {
	title: string;
	titleLabel?: string;
	onTitleClick?: () => void;
	previousLabel: string;
	nextLabel: string;
	previousEnabled: boolean;
	nextEnabled: boolean;
	onPrevious: () => void;
	onNext: () => void;
};

export const FlatRowDatePanelHeader: FC<Props> = ({
	title,
	titleLabel,
	onTitleClick,
	previousLabel,
	nextLabel,
	previousEnabled,
	nextEnabled,
	onPrevious,
	onNext,
}) => {
	const { palette, spacingTokens, radii, iconSize } = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			px={spacingTokens.xl}
			pb={spacingTokens.md}
		>
			<FlatRowDatePanelArrow
				icon={ChevronLeft}
				label={previousLabel}
				enabled={previousEnabled}
				onClick={onPrevious}
			/>
			{onTitleClick && (
				<ButtonBase
					onClick={onTitleClick}
					aria-label={titleLabel}
					sx={{
						gap: spacingTokens.xs,
						px: spacingTokens.sm,
						py: spacingTokens.xs,
						borderRadius: radii.md,
					}}
				>
					<Typography variant="bodyStrong" tabular>
						{title}
					</Typography>
					<ChevronDown
						aria-hidden
						size={iconSize.sm}
						color={palette.blue[600]}
					/>
				</ButtonBase>
			)}
			{!onTitleClick && (
				<Typography
					variant="bodyStrong"
					tabular
					px={spacingTokens.sm}
					py={spacingTokens.xs}
				>
					{title}
				</Typography>
			)}
			<FlatRowDatePanelArrow
				icon={ChevronRight}
				label={nextLabel}
				enabled={nextEnabled}
				onClick={onNext}
			/>
		</Stack>
	);
};
